(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aa-hero-carousel-v2"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const SELECTOR = '[data-aa-carousel]';
    const SWIPE_THRESHOLD = 40;

    function init(root) {
      if (!root || root.dataset.aaInit === '1') return;
      root.dataset.aaInit = '1';

      const slides = Array.from(root.querySelectorAll('[data-aa-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-aa-dot]'));
      const prevBtn = root.querySelector('[data-aa-prev]');
      const nextBtn = root.querySelector('[data-aa-next]');
      const pauseBtn = root.querySelector('[data-aa-pause]');
      const viewport = root.querySelector('[data-aa-viewport]');

      if (slides.length <= 1) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplay = root.dataset.autoplay === 'true' && !reduceMotion;
      const autoplayMs = parseInt(root.dataset.autoplayMs, 10) || 5000;
      const transitionMs = parseInt(root.dataset.transitionMs, 10) || 800;
      const pauseOnHover = root.dataset.pauseOnHover === 'true';

      let current = slides.findIndex((s) => s.classList.contains('is-active'));
      if (current < 0) current = 0;
      let timer = null;
      let leavingTimer = null;
      let userPaused = false;
      let hovered = false;
      let focused = false;
      let visible = true;

      function setSlideTabindex(slide, value) {
        const items = slide.querySelectorAll('a, button');
        items.forEach((el) => el.setAttribute('tabindex', value));
      }

      function setSlide(next) {
        next = ((next % slides.length) + slides.length) % slides.length;
        if (next === current) return;

        const prev = slides[current];
        const target = slides[next];

        prev.classList.remove('is-active');
        prev.classList.add('is-leaving');
        prev.setAttribute('aria-hidden', 'true');
        setSlideTabindex(prev, '-1');

        target.classList.add('is-active');
        target.classList.remove('is-leaving');
        target.setAttribute('aria-hidden', 'false');
        setSlideTabindex(target, '0');

        dots.forEach((dot, i) => {
          const active = i === next;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
          if (active) {
            const ring = dot.querySelector('.aa-hero-carousel__dot-progress');
            if (ring) {
              ring.style.animation = 'none';
              void ring.offsetWidth;
              ring.style.animation = '';
            }
          }
        });

        if (leavingTimer) window.clearTimeout(leavingTimer);
        leavingTimer = window.setTimeout(function () {
          prev.classList.remove('is-leaving');
        }, transitionMs + 50);

        current = next;
      }

      function next() { setSlide(current + 1); }
      function prev() { setSlide(current - 1); }

      function shouldRun() {
        return autoplay && !userPaused && visible && !(pauseOnHover && hovered) && !focused;
      }

      function applyPausedAttr() {
        root.dataset.paused = shouldRun() ? 'false' : 'true';
      }

      function startTimer() {
        stopTimer();
        if (!shouldRun()) { applyPausedAttr(); return; }
        applyPausedAttr();
        timer = window.setInterval(next, autoplayMs);
      }

      function stopTimer() {
        if (timer) { window.clearInterval(timer); timer = null; }
        applyPausedAttr();
      }

      if (nextBtn) nextBtn.addEventListener('click', () => { focused = false; next(); startTimer(); });
      if (prevBtn) prevBtn.addEventListener('click', () => { focused = false; prev(); startTimer(); });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const idx = parseInt(dot.dataset.index, 10);
          if (!Number.isNaN(idx)) { focused = false; setSlide(idx); startTimer(); }
        });
      });

      if (pauseBtn) {
        pauseBtn.addEventListener('click', () => {
          userPaused = !userPaused;
          pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
          if (userPaused) stopTimer(); else startTimer();
        });
      }

      root.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); next(); startTimer(); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); startTimer(); }
      });

      if (pauseOnHover) {
        root.addEventListener('mouseenter', () => { hovered = true; startTimer(); });
        root.addEventListener('mouseleave', () => { hovered = false; startTimer(); });
      }
      root.addEventListener('focusin', () => { focused = true; startTimer(); });
      root.addEventListener('focusout', (e) => {
        if (!root.contains(e.relatedTarget)) { focused = false; startTimer(); }
      });

      let pointerStartX = 0;
      let pointerStartY = 0;
      let pointerActive = false;
      let pointerMoved = false;
      if (viewport) {
        viewport.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          pointerActive = true;
          pointerMoved = false;
          pointerStartX = e.clientX;
          pointerStartY = e.clientY;
        });
        viewport.addEventListener('pointermove', (e) => {
          if (!pointerActive) return;
          if (Math.abs(e.clientX - pointerStartX) > 6 || Math.abs(e.clientY - pointerStartY) > 6) {
            pointerMoved = true;
          }
        });
        viewport.addEventListener('pointerup', (e) => {
          if (!pointerActive) return;
          pointerActive = false;
          const dx = e.clientX - pointerStartX;
          const dy = e.clientY - pointerStartY;
          if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
            if (dx < 0) next(); else prev();
            startTimer();
          }
        });
        viewport.addEventListener('pointercancel', () => { pointerActive = false; });
        viewport.addEventListener('dragstart', (e) => { e.preventDefault(); });
        viewport.addEventListener('click', (e) => {
          if (pointerMoved) {
            e.preventDefault();
            e.stopPropagation();
            pointerMoved = false;
          }
        }, true);
      }

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => { visible = entry.isIntersecting; startTimer(); });
        }, { threshold: 0.2 });
        io.observe(root);
      }

      document.addEventListener('visibilitychange', () => {
        visible = !document.hidden;
        startTimer();
      });

      startTimer();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll(SELECTOR).forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (e) => {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-tier-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const MOBILE = '(max-width: 749px)';
    const SWIPE = 40;
    const TOLERANCE = 6;

    class AATierCardsTabs {
      constructor(root) {
        this.root = root;
        this.strip = root.querySelector('[data-aa-tiercards-tabs]');
        this.viewport = root.querySelector('[data-aa-tiercards-viewport]');
        this.track = root.querySelector('[data-aa-tiercards-track]');
        this.panels = Array.from(root.querySelectorAll('[data-aa-tier-panel]'));
        if (!this.strip || !this.track || !this.panels.length) return;

        this.index = 0;
        this.active = false;
        this.buildTabs();
        if (!this.tabs.length) return;

        this.mq = window.matchMedia(MOBILE);
        this.onChange = () => (this.mq.matches ? this.attach() : this.detach());
        this.mq.addEventListener('change', this.onChange);
        this.onChange();
      }

      // Liquid can't read block settings, so the strip is built from what the
      // cards rendered: their name and highlight state ride on data attributes.
      buildTabs() {
        this.strip.textContent = '';
        this.strip.setAttribute('role', 'tablist');

        this.panels.forEach((panel, i) => {
          const name = panel.dataset.tierName || '';
          if (!name) return;

          const tab = document.createElement('button');
          tab.type = 'button';
          tab.className = 'aa-tier__tab';
          if (panel.dataset.highlight === 'true') {
            tab.classList.add('aa-tier__tab--highlighted');
          }
          tab.id = `${this.root.id}-tab-${i}`;
          tab.dataset.index = String(i);
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panel.id);

          const icon = panel.querySelector('[data-aa-tier-tabicon]');
          if (icon && panel.dataset.highlight === 'true') {
            tab.appendChild(icon.content.cloneNode(true));
          }

          const label = document.createElement('span');
          label.className = 'aa-tier__tab-text';
          label.textContent = name;
          tab.appendChild(label);

          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);

          this.strip.appendChild(tab);
        });

        this.tabs = Array.from(this.strip.querySelectorAll('.aa-tier__tab'));
      }

      attach() {
        if (this.active) return;
        this.active = true;
        this.strip.hidden = false;

        this.onTabClick = (e) => this.select(Number(e.currentTarget.dataset.index), true);
        this.onKeydown = (e) => this.handleKey(e);
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', this.onTabClick);
          tab.addEventListener('keydown', this.onKeydown);
        });

        this.bindPointer();
        this.onResize = () => this.render(false);
        window.addEventListener('resize', this.onResize);
        this.render(false);
      }

      detach() {
        if (!this.active) return;
        this.active = false;
        this.strip.hidden = true;

        this.tabs.forEach((tab) => {
          tab.removeEventListener('click', this.onTabClick);
          tab.removeEventListener('keydown', this.onKeydown);
        });
        this.panels.forEach((panel) => {
          panel.removeAttribute('aria-hidden');
          panel.removeAttribute('inert');
        });
        this.unbindPointer();
        window.removeEventListener('resize', this.onResize);

        this.track.style.transform = '';
        this.track.style.height = '';
        this.root.classList.remove('is-dragging');
      }

      select(i, focusTab) {
        if (i < 0 || i >= this.tabs.length) return;
        this.index = i;
        this.render(focusTab);
      }

      render(focusTab) {
        this.tabs.forEach((tab, i) => {
          const on = i === this.index;
          tab.setAttribute('aria-selected', String(on));
          tab.tabIndex = on ? 0 : -1;
          if (on) {
            if (focusTab) tab.focus();
            tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        });

        this.panels.forEach((panel, i) => {
          const on = i === this.index;
          panel.setAttribute('aria-hidden', String(!on));
          panel.toggleAttribute('inert', !on);
        });

        this.track.style.transform = `translateX(-${this.index * 100}%)`;
        const active = this.panels[this.index];
        if (active) this.track.style.height = `${active.offsetHeight}px`;
      }

      handleKey(e) {
        const last = this.tabs.length - 1;
        let next = null;
        if (e.key === 'ArrowRight') next = Math.min(this.index + 1, last);
        else if (e.key === 'ArrowLeft') next = Math.max(this.index - 1, 0);
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = last;
        if (next === null) return;
        e.preventDefault();
        this.select(next, true);
      }

      bindPointer() {
        this.startX = 0;
        this.startY = 0;
        this.down = false;
        this.moved = false;

        this.onDown = (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          this.down = true;
          this.moved = false;
          this.startX = e.clientX;
          this.startY = e.clientY;
        };
        this.onMove = (e) => {
          if (!this.down) return;
          const dx = e.clientX - this.startX;
          const dy = e.clientY - this.startY;
          if (Math.abs(dx) > TOLERANCE || Math.abs(dy) > TOLERANCE) this.moved = true;
          if (this.moved && Math.abs(dx) > Math.abs(dy)) {
            this.root.classList.add('is-dragging');
            const pct = (dx / this.viewport.offsetWidth) * 100;
            this.track.style.transform = `translateX(calc(-${this.index * 100}% + ${pct}%))`;
          }
        };
        this.onUp = (e) => {
          if (!this.down) return;
          this.down = false;
          this.root.classList.remove('is-dragging');
          const dx = e.clientX - this.startX;
          const dy = e.clientY - this.startY;
          if (Math.abs(dx) > SWIPE && Math.abs(dx) > Math.abs(dy)) {
            this.select(dx < 0 ? Math.min(this.index + 1, this.tabs.length - 1) : Math.max(this.index - 1, 0), false);
          } else {
            this.render(false);
          }
        };
        this.onCancel = () => {
          this.down = false;
          this.root.classList.remove('is-dragging');
          this.render(false);
        };
        this.onClickCapture = (e) => {
          if (this.moved) {
            e.preventDefault();
            e.stopPropagation();
            this.moved = false;
          }
        };
        this.onDragStart = (e) => e.preventDefault();

        this.viewport.addEventListener('pointerdown', this.onDown);
        this.viewport.addEventListener('pointermove', this.onMove);
        this.viewport.addEventListener('pointerup', this.onUp);
        this.viewport.addEventListener('pointercancel', this.onCancel);
        this.viewport.addEventListener('click', this.onClickCapture, true);
        this.viewport.addEventListener('dragstart', this.onDragStart);
      }

      unbindPointer() {
        this.viewport.removeEventListener('pointerdown', this.onDown);
        this.viewport.removeEventListener('pointermove', this.onMove);
        this.viewport.removeEventListener('pointerup', this.onUp);
        this.viewport.removeEventListener('pointercancel', this.onCancel);
        this.viewport.removeEventListener('click', this.onClickCapture, true);
        this.viewport.removeEventListener('dragstart', this.onDragStart);
      }
    }

    const init = (scope) => {
      scope.querySelectorAll('[data-aa-tiercards][data-mobile-layout="tabs"]').forEach((root) => {
        if (root.dataset.aaTierReady === 'true') return;
        root.dataset.aaTierReady = 'true';
        new AATierCardsTabs(root);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-tier-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const MOBILE = '(max-width: 749px)';
    const SWIPE = 40;
    const TOLERANCE = 6;

    class AATierLedgerTabs {
      constructor(root) {
        this.root = root;
        this.tabs = Array.from(root.querySelectorAll('[data-aa-tier-tab]'));
        this.strip = root.querySelector('[data-aa-tier-tabs]');
        this.viewport = root.querySelector('[data-aa-tier-viewport]');
        if (!this.tabs.length || !this.viewport) return;

        this.index = 1;
        this.max = this.tabs.length;
        this.active = false;
        this.mq = window.matchMedia(MOBILE);
        this.onChange = () => (this.mq.matches ? this.attach() : this.detach());
        this.mq.addEventListener('change', this.onChange);
        this.onChange();
      }

      attach() {
        if (this.active) return;
        this.active = true;

        this.onTabClick = (e) => this.select(Number(e.currentTarget.dataset.index));
        this.onKeydown = (e) => this.handleKey(e);
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', this.onTabClick);
          tab.addEventListener('keydown', this.onKeydown);
        });

        this.bindPointer();
        this.render(false);
      }

      detach() {
        if (!this.active) return;
        this.active = false;
        this.tabs.forEach((tab) => {
          tab.removeEventListener('click', this.onTabClick);
          tab.removeEventListener('keydown', this.onKeydown);
        });
        this.unbindPointer();
        this.root.setAttribute('data-active', '1');
      }

      select(i) {
        if (!i || i < 1 || i > this.max) return;
        this.index = i;
        this.render(true);
      }

      render(focusTab) {
        this.root.setAttribute('data-active', String(this.index));
        this.tabs.forEach((tab) => {
          const on = Number(tab.dataset.index) === this.index;
          tab.setAttribute('aria-selected', String(on));
          tab.tabIndex = on ? 0 : -1;
          if (on) {
            if (focusTab) tab.focus();
            tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        });
      }

      handleKey(e) {
        let next = null;
        if (e.key === 'ArrowRight') next = Math.min(this.index + 1, this.max);
        else if (e.key === 'ArrowLeft') next = Math.max(this.index - 1, 1);
        else if (e.key === 'Home') next = 1;
        else if (e.key === 'End') next = this.max;
        if (next === null) return;
        e.preventDefault();
        this.select(next);
      }

      bindPointer() {
        this.startX = 0;
        this.startY = 0;
        this.down = false;
        this.moved = false;

        this.onDown = (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          this.down = true;
          this.moved = false;
          this.startX = e.clientX;
          this.startY = e.clientY;
        };
        this.onMove = (e) => {
          if (!this.down) return;
          if (Math.abs(e.clientX - this.startX) > TOLERANCE || Math.abs(e.clientY - this.startY) > TOLERANCE) {
            this.moved = true;
          }
        };
        this.onUp = (e) => {
          if (!this.down) return;
          this.down = false;
          const dx = e.clientX - this.startX;
          const dy = e.clientY - this.startY;
          if (Math.abs(dx) > SWIPE && Math.abs(dx) > Math.abs(dy)) {
            const next = dx < 0 ? this.index + 1 : this.index - 1;
            if (next >= 1 && next <= this.max) {
              this.index = next;
              this.render(false);
            }
          }
        };
        this.onCancel = () => { this.down = false; };
        this.onClickCapture = (e) => {
          if (this.moved) {
            e.preventDefault();
            e.stopPropagation();
            this.moved = false;
          }
        };
        this.onDragStart = (e) => e.preventDefault();

        this.viewport.addEventListener('pointerdown', this.onDown);
        this.viewport.addEventListener('pointermove', this.onMove);
        this.viewport.addEventListener('pointerup', this.onUp);
        this.viewport.addEventListener('pointercancel', this.onCancel);
        this.viewport.addEventListener('click', this.onClickCapture, true);
        this.viewport.addEventListener('dragstart', this.onDragStart);
      }

      unbindPointer() {
        this.viewport.removeEventListener('pointerdown', this.onDown);
        this.viewport.removeEventListener('pointermove', this.onMove);
        this.viewport.removeEventListener('pointerup', this.onUp);
        this.viewport.removeEventListener('pointercancel', this.onCancel);
        this.viewport.removeEventListener('click', this.onClickCapture, true);
        this.viewport.removeEventListener('dragstart', this.onDragStart);
      }
    }

    const init = (scope) => {
      scope.querySelectorAll('[data-aa-tier][data-mobile-layout="tabs"]').forEach((root) => {
        if (root.dataset.aaTierReady === 'true') return;
        root.dataset.aaTierReady = 'true';
        new AATierLedgerTabs(root);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
